import { useMutation } from 'react-query';
import { controlBackdropLoading, removeCache, repairService } from '../../services';
import { RepairUpdateProps, RepairUpdateImagesProps, IdProps } from '../../types';

export const useUpdateRepairMutation = () => {
  return useMutation((props: RepairUpdateProps) => repairService.update(props), {
    onSettled: () => {
      removeCache(['repairs', 'repair']);
    },
  });
};

export const useSetPriceRepairMutation = () => {
  return useMutation((props: RepairUpdateProps[]) => repairService.setPrice(props), {
    onSettled: () => {
      removeCache(['repairs', 'repair']);
    },
  });
};

export const useCompleteRepairMutation = () => {
  return useMutation((props: IdProps) => repairService.complete(props), {
    onSettled: () => {
      removeCache(['repairs', 'repair']);
    },
  });
};

export const useRepairDeleteMutation = () => {
  return useMutation((props: IdProps) => repairService.delete(props), {
    onSettled: () => {
      removeCache(['repairs', 'repair']);
    },
  });
};

export const useUpdateImagesRepairMutation = () => {
  return useMutation(
    ({ id, photos = [], action }: RepairUpdateImagesProps) => {
      controlBackdropLoading(1);

      return repairService.updateImages({ id, photos, action });
    },
    {
      onSettled: () => {
        removeCache(['repairs', 'repair']);
        controlBackdropLoading(-1);
      },
    },
  );
};
